import { IJsonLogic } from './json-logic.interface'

export interface IFilterCommands {
  and: (...commands: any) => IJsonLogic
  or: (...commands: any) => IJsonLogic
  inArray: (...commands: any) => IJsonLogic
  variable: (key: string) => IJsonLogic
  equals: (...commands: any) => IJsonLogic
  doesNotEqual: (...commands: any) => IJsonLogic
  lt: (...commands: any) => IJsonLogic
  lte: (...commands: any) => IJsonLogic
  gt: (...commands: any) => IJsonLogic
  gte: (...commands: any) => IJsonLogic
  is: IIsFilters
  not: INotFilters
}

export interface IIsFilters {
  featured: IJsonLogic
  listed: IJsonLogic
  equipment: (id: string) => IJsonLogic
}

export interface INotFilters {
  featured: IJsonLogic
  equipment: (id: string) => IJsonLogic
}

export interface IHasFilters {
  price: IJsonLogic
}

export interface IFilter {
  id: FilterId
  state: any
  isEmpty: (state: any) => boolean
}

export enum FilterId {
  Unknown = 'Unknown',
  CatSubcat = 'CatSubcat',
  MakeModel = 'MakeModel',
  Meter = 'Meter',
  PriceRange = 'PriceRange',
  MilesRange = 'MilesRange',
  HoursRange = 'HoursRange',
  ZipCode = 'Location',
  Year = 'Year',
  Location = 'Location-2',
  QuickFilters = 'QuickFilters',
  Option01Date = 'option_01_date',
  Option02Date = 'option_02_date',
  Option01String = 'option_01_string',
  Option02String = 'option_02_string',
  Option03String = 'option_03_string',
  Option01Numeric = 'option_01_numeric',
  Option02Numeric = 'option_02_numeric',
  Option01Bit = 'option_01_bit',
  Option02Bit = 'option_02_bit',
  Option01Financial = 'option_01_financial',
  Option02Financial = 'option_02_financial',
  Option03Financial = 'option_03_financial',
  Option04Financial = 'option_04_financial',
}

export interface IFilterItem {
  value: string
  field: string
  children?: IFilterItem[]
}

export interface IFilterSettings {
  [key: string]: IFilterItem[]
}

export interface IGetFiltersResponse {
  results: IFilterSettings[]
}
